/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';
import type { PointOfService } from './PointOfService';
import {
    PointOfServiceFromJSON,
    PointOfServiceFromJSONTyped,
    PointOfServiceToJSON,
} from './PointOfService';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * Representation of a Pickup Order Entry Group
 * @export
 * @interface PickupOrderEntryGroup
 */
export interface PickupOrderEntryGroup {
    /**
     * 
     * @type {Price}
     * @memberof PickupOrderEntryGroup
     */
    totalPriceWithTax?: Price;
    /**
     * List of order entries
     * @type {Array<OrderEntry>}
     * @memberof PickupOrderEntryGroup
     */
    entries?: Array<OrderEntry>;
    /**
     * Quantity of order entries in a group
     * @type {number}
     * @memberof PickupOrderEntryGroup
     */
    quantity?: number;
    /**
     * 
     * @type {PointOfService}
     * @memberof PickupOrderEntryGroup
     */
    deliveryPointOfService?: PointOfService;
    /**
     * Distance calculated to pickup place
     * @type {number}
     * @memberof PickupOrderEntryGroup
     */
    distance?: number;
}

/**
 * Check if a given object implements the PickupOrderEntryGroup interface.
 */
export function instanceOfPickupOrderEntryGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PickupOrderEntryGroupFromJSON(json: any): PickupOrderEntryGroup {
    return PickupOrderEntryGroupFromJSONTyped(json, false);
}

export function PickupOrderEntryGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): PickupOrderEntryGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalPriceWithTax': !exists(json, 'totalPriceWithTax') ? undefined : PriceFromJSON(json['totalPriceWithTax']),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(OrderEntryFromJSON)),
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'deliveryPointOfService': !exists(json, 'deliveryPointOfService') ? undefined : PointOfServiceFromJSON(json['deliveryPointOfService']),
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
    };
}

export function PickupOrderEntryGroupToJSON(value?: PickupOrderEntryGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalPriceWithTax': PriceToJSON(value.totalPriceWithTax),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(OrderEntryToJSON)),
        'quantity': value.quantity,
        'deliveryPointOfService': PointOfServiceToJSON(value.deliveryPointOfService),
        'distance': value.distance,
    };
}

